import React from 'react';

export default {
  width: 17,
  height: 12,
  content: (
    <path d="M15.865.895c.5.518.664 1.694.664 1.694s.167 1.38.167 2.76v1.295c0 1.381-.167 2.762-.167 2.762s-.164 1.175-.664 1.693c-.572.612-1.206.676-1.565.711l-.108.012c-2.336.173-5.844.178-5.844.178s-4.341-.04-5.677-.172a3.633 3.633 0 00-.227-.032c-.423-.052-1.087-.133-1.614-.697-.5-.518-.663-1.693-.663-1.693S0 8.026 0 6.644V5.35c0-1.38.167-2.761.167-2.761S.33 1.413.83.895C1.403.282 2.038.22 2.397.184l.106-.011C4.84 0 8.344 0 8.344 0h.007s3.505 0 5.841.173a5.1 5.1 0 00.107.011c.358.035.993.098 1.566.711zM6.625 3.42v4.794l4.51-2.389-4.51-2.405z" />
  )
};
